export default "__VITE_ASSET__BbITR8oN__"